const mailId = "L-TT.Podcast";
const domain = "accenture.com"
export const FaqData = [
  {
    id: "01",
    Question: "What is the L&TT Unplugged initiative?",
    Answer: `
      <p>
        L&TT Unplugged is a podcasting platform created and managed by the
        Learning & Talent Transformation team to drive impactful learning
        experiences. Designed for the people at L&TT, it aims to spark
        meaningful conversations. <br />
        <br />
        L&TT Unplugged brings you episodic stories and a series of podcasts that
        you can stream anytime, anywhere. These episodes range from insightful
        conversations to captivating storytelling, covering a wide array of
        topics to inspire, inform, and connect.
      </p>
    `,
  },
  {
    id: "02",
    Question: "How does L&TT Unplugged work?",
    Answer: `
      <p>
        L&TT Unplugged will facilitate knowledge sharing through ‘Thought
        Leadership Sessions,’ sharing relevant content by SMEs (subject matter
        experts), promotion and raising awareness of learning programs, creating
        co-branded series through cross-functional collaboration, and more.
        <br />
        <br />
        One who may want to create their own podcast will have to follow the
        standard procedure where the initial phase is to plan and finalize their
        content topic and episode frequency. Once planning is done and
        communicated to the Learning Experiences team, share your recorded
        podcast for evaluation and publishing. Once the podcast is published,
        you will be notified.
      </p>
    `,
  },
  {
    id: "03",
    Question: "Why should I start a podcast?",
    Answer: `
      <p>
        Podcasts provide a unique experience, often resembling the familiarity
        of listening to a natural conversation. Many podcasts also leverage
        storytelling elements, making them engaging and enjoyable for audiences.
        With a well-thought-out strategy, compelling content, and effective
        execution, podcasts can become powerful tools for enhancing branding and
        driving learning engagement. <br />
        Podcasts are leveraged to:
        <ul style={{ marginLeft: "1.5%", marginTop: "1%" }}>
          <li>Create a personalized and immersive experience </li>
          <li>Help build and maintain essential industry connections </li>
          <li>Enable teams to establish themselves as ‘Thought Leaders’</li>
          <li>
            Provide an innovative platform for audiences to access and consume
            your content
          </li>
        </ul>
      </p>
    `,
  },
  {
    id: "04",
    Question: "Will there be a cost for publishing podcasts on L&TT Unplugged?",
    Answer: ` <p> There is no cost involved with the submission of a podcast for L&TT initiatives. </p>`,
  },
  {
    id: "05",
    Question: "Is Leadership approval (email) required?",
    Answer: `<p> Every podcast created at Accenture requires leadership approval. The name and email address of the approver who has finalized the podcast requirements must be provided. </p>`,
  },
  {
    id: "06",
    Question:
      "What are the things to be considered before I start a podcast show?",
    Answer: `
      <p>
        Podcasts have become so popular in recent years due to their
        accessibility, availability, diverse content, and authentic voices.
        Podcasts provide a platform for expression, giving you multiple
        opportunities to learn and network. However, starting a podcast requires
        careful consideration of a range of factors. Before diving into
        podcasting, you must consider the aspects mentioned below:
        <ul>
          <li>Does your audience listen to podcasts?</li>
          <li>
            What existing initiative and objective would this podcast support?
          </li>
          <li>Will it offer something new (idea/topic not covered before)</li>
          <li>
            Do you have time and resources to produce quality podcast episodes
            regularly?
          </li>
          <li>What should be the frequency between 2 episodes of a podcast?</li>
          <li>Would you listen to your podcast as an audience?</li>
        </ul>
      </p>
    `,
  },
  {
    id: "07",
    Question: "Who can create a podcast with L&TT Unplugged?",
    Answer: `<p>Anyone from the Learning & Talent Transformation (L&TT) team can create a podcast. However, the members must have approvals from the Leads and Internal Communications (IC) team at Learning Experiences, L&TT.</p>`,
  },
  {
    id: "08",
    Question: "How to create a podcast?",
    Answer: `
      <p>
        Here are the steps you need to follow to create a podcast.
        <ul style={{ marginLeft: "1.5%", marginTop: "1%", marginBottom: "1%" }}>
          <li>
            Plan your podcast content (make sure there is no similar existing
            topic).
          </li>
          <li>Maintain the best practices (Refer to podcast guidebook).</li>
          <li>Record your podcast using self-help tools.</li>
          <li>Follow standard recording process and guidelines.</li>
          <li>Get your podcast finalized and published.</li>
        </ul>
        <p>
          You may refer to the
          <a
            href="https://atci.lkm.accenture.com/Podcast/images/Resources/Podcast_Final.mp4"
            target="blank"
          >
            “How to create a podcast”
          </a>
          tutorial video to learn more and understand the process.
        </p>
      </p>
    `,
  },
  {
    id: "09",
    Question: "How many episodes can be added to my podcast?",
    Answer: `<p> You can add as many new episodes as you want. However, this needs to be planned and communicated while submitting the podcast request.</p>`,
  },
  {
    id: "10",
    Question:
      "What is the supported file size? What should be the length of each episode?",
    Answer: `
      <p>
        Your podcast episodes can be of 20 to 30 minutes. To learn more about
        the best practices for creating and publishing your podcast on LKM
        Unplugged, refer to Podcast Guidebook.
      </p>
    `,
  },
  {
    id: "11",
    Question: "What type of podcasts can I create?",
    Answer: `
      <p>
        You may create podcasts related to the below industries/topics that
        adhere to
        <a
          href="https://in.accenture.com/legal/ipold/accenture-social-media/"
          target="_blank"
          style={{ textDecoration: "none" }}
        >
          Accenture Brand Guidelines.
        </a>
        <ul style={{ marginLeft: "1.5%", marginTop: "1%", marginBottom: "1%" }}>
          <li>Financial services [Banking, Capital Markets, Insurance] </li>
          <li>Health and public services </li>
          <li>
            Communications, media, and technology [Comms and Media, High Tech,
            Software & platforms]
          </li>
          <li>
            Products [CG&S, Retail, Travel services, Industrial (includes Auto
            A&D), Life Sciences]
          </li>
          <li>Resources [Chemicals & neutral resources, Utilities, Energy]</li>
        </ul>
      </p>
    `,
  },

  {
    id: "12",
    Question: "What are the distribution channels available?",
    Answer: `<p> Our team currently manages to host podcasts on Media Exchange. You may also stay tuned to L&TT Viva Engage Community daily engagements to find updates on the latest episodes of your shortlisted podcasts.</p>`,
  },
  {
    id: "13.",
    Question: "Where can we share our podcast?",
    Answer: `
      <p>
        You may share it on <strong> Viva Engage </strong> or E-mails within the
        organization. However, external social media sharing is against the
        guidelines.
      </p>
    `,
  },
  {
    id: "14",
    Question: "Who can access L&TT Unplugged?",
    Answer: `<p>All people at Accenture can access L&TT Unplugged.</p>`,
  },
  {
    id: "15.",
    Question: "Who will be the single point of contact for L&TT Unplugged?",
    Answer: `<p>You may reach out to
        <a
          href="mailto:L-TT.Podcast;"
          target="_blank"
        >
          ${mailId}@${domain}
        </a>
      </p>`,
  },
];
